import { IconButton } from '@material-ui/core';
import RemoveRedEye from '@material-ui/icons/RemoveRedEye';
import * as React from 'react';

export function MaskedDisplay({ value }) {
  const [show, setShow] = React.useState(false);
  if (!value) {
    return null;
  }
  // only show first and last characters, mask the rest
  const maskedValue = value.length > 2 ? `${value[0]}${'*'.repeat(value.length - 2)}${value[value.length - 1]}` : value;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      {show ? value : maskedValue}
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setShow(!show);
        }}
        title={show ? 'Hide' : 'Show'}
        style={{ marginLeft: 4 }}
      >
        <RemoveRedEye />
      </IconButton>
    </span>
  );
}
